import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6 shadow rounded-md min-w-full min-h-full p-5 bg-white" }
const _hoisted_2 = { class: "col-span-3 flex justify-start gap-x-2 align-middle" }
const _hoisted_3 = { class: "col-span-3 flex align-top justify-start gap-x-1 text-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_6 = { class: "col-span-3 flex justify-start gap-x-5 min-h-13" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_9 = { class: "col-span-3 flex gap-y-2 flex-col justify-around gap-x-5 pt-4 xl:flex-row" }

import {
		computed,
		ref,
		onMounted
	} from 'vue'
	
	import { 
		localesStore
	} from '@/store/locales'

	import {
		useI18n
	} from 'vue-i18n'
	import {
		enterRoleTime
	} from '../mutations'

	
	const __default__ = { name: 'JobRoleTimeCard' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		role: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {


	const {t} = useI18n()
	const _localesStore = localesStore()

	const props = __props

	const loading = ref(false)
	const departureDisabled = ref(false)
	const arrivalDisabled = ref(false)
	const error = ref(false)
	const errorMsg = ref("")
	const departureTime = ref("")
	const arrivalTime = ref("")

	onMounted(() => {
		if(props.role.departureTime) {
			departureTime.value = props.role.departureTime
			departureDisabled.value = true
		}
		if(props.role.arrivalTime) {
			arrivalTime.value = props.role.arrivalTime
			arrivalDisabled.value = true
		}
	})

	const departureLabel = computed(() => {
		if(!departureTime.value) {
			return t("staffJobs.submitDeparture")
		}
		return `${t('staffJobs.departed')}: ${departureTime.value.slice(0, 5)}`
	})

	const arrivalLabel = computed(() => {
		if(!arrivalTime.value) {
			return t("staffJobs.submitArrival")
		}
		return `${t('staffJobs.arrived')}: ${arrivalTime.value.slice(0, 5)}`
	})

	async function submitDepartureTime() {
		try{
			loading.value = true
			departureDisabled.value = true

			const time = new Date()
			const timeString = time.toTimeString().split(" ")[0]
			const params = JSON.stringify({
				"time": timeString,
				"roleID": props.role.roleID,
				"type": "departure"
			})
			const res = await enterRoleTime(params)
			const fmRes = JSON.parse(res.response.scriptResult)

			if (fmRes.errorCode !== 0) {
				throw new Error(fmRes.errorMessage)
			}

			departureTime.value = timeString
			departureDisabled.value = true
		}catch(e: any) {
			error.value = true
			errorMsg.value = e.message
			departureDisabled.value = false
		}finally{
			loading.value = false
		}
	}

	async function submitArrivalTime() {
		try{
			loading.value = true
			departureDisabled.value = true

			const time = new Date()
			const timeString = time.toTimeString().split(" ")[0]
			const params = JSON.stringify({
				"time": timeString,
				"roleID": props.role.roleID,
				"type": "arrival"
			})
			const res = await enterRoleTime(params)
			const fmRes = JSON.parse(res.response.scriptResult)
			
			if (fmRes.errorCode !== 0) {
				throw new Error(fmRes.errorMessage)
			}

			arrivalTime.value = timeString
			arrivalDisabled.value = true
		}catch(e: any) {
			error.value = true
			errorMsg.value = e.message
			arrivalDisabled.value = false
		}finally{
			loading.value = false
		}
	}


return (_ctx: any,_cache: any) => {
  const _component_BuildingOfficeIcon = _resolveComponent("BuildingOfficeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_BuildingOfficeIcon, { class: "w-6" })
        ]),
        _createVNode(_component_router_link, {
          class: "underline",
          to: {name: 'JobDetails', params: {recordId: props.role.recordID}}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.role.companyDisplay), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(props.role.dateStart), 1),
        _createElementVNode("span", null, _toDisplayString(`(${_unref(_localesStore).getLabel(props.role.dateDayCode)})`), 1),
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(props.role.typeDisplay), 1),
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(props.role.categoryDisplay), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(_localesStore).getLabel('233')), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(props.role.timeArrival.slice(0,5)), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      (error.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errorMsg.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_tw_button, {
        disabled: departureDisabled.value,
        loading: loading.value,
        onClick: submitDepartureTime,
        class: _normalizeClass(departureDisabled.value ? 'button bg-gray-300 w-full text-black' : 'button bg-brand-500 w-full text-white hover:btn-brand')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(departureLabel.value), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "class"]),
      _createVNode(_component_tw_button, {
        disabled: arrivalDisabled.value,
        loading: loading.value,
        onClick: submitArrivalTime,
        class: _normalizeClass(arrivalDisabled.value ? 'button bg-gray-300 w-full text-black' : 'button bg-brand-500 w-full text-white hover:btn-brand')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(arrivalLabel.value), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "class"])
    ])
  ]))
}
}

})